import React, { useCallback, useState } from "react";
import { useI18n } from "@/i18n/I18nProvider";
import { formatQty } from "./vipSimulatorUtils";

export default function QuantityStepper({ value, onChange, step, min, max, disabled }) {
    const { t, lang } = useI18n();
    const [editing, setEditing] = useState(false);
    const [draft, setDraft] = useState(String(value));

    const fmt = (n) => formatQty(n, lang);

    const apply = useCallback(
        (raw) => {
            const n = typeof raw === "number" ? raw : parseInt(String(raw).replace(/\D/g, ""), 10);
            onChange(Number.isFinite(n) ? n : min);
        },
        [onChange, min],
    );

    if (disabled) return null;

    return (
        <div
            className="vip-sim-stepper"
            onPointerDown={(e) => e.stopPropagation()}
        >
            <button
                type="button"
                className="vip-sim-stepper__btn"
                aria-label={t("simulator.stepper.decrease")}
                onClick={(e) => {
                    e.stopPropagation();
                    onChange(value - step);
                }}
            >
                −
            </button>
            <input
                type="text"
                inputMode="numeric"
                autoComplete="off"
                className="vip-sim-stepper__mid"
                readOnly={!editing}
                value={editing ? draft : fmt(value)}
                aria-label={t("simulator.stepper.quantity")}
                onClick={(e) => {
                    e.stopPropagation();
                    setEditing(true);
                    setDraft(String(value));
                }}
                onPointerDown={(e) => e.stopPropagation()}
                onChange={(e) => setDraft(e.target.value.replace(/\D/g, ""))}
                onBlur={() => {
                    setEditing(false);
                    apply(draft === "" ? value : parseInt(draft, 10));
                }}
                onKeyDown={(e) => {
                    if (e.key === "Enter") e.target.blur();
                }}
            />
            <button
                type="button"
                className="vip-sim-stepper__btn"
                aria-label={t("simulator.stepper.increase")}
                onClick={(e) => {
                    e.stopPropagation();
                    onChange(value + step);
                }}
            >
                +
            </button>
        </div>
    );
}
